import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";

import vClickOutside from "v-click-outside";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.prototype.$liff = window.liff;

Vue.config.productionTip = false;

Vue.directive("outside", vClickOutside);

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("debugMode") === "true") {
  import("vconsole").then(({ default: VConsole }) => {
    new VConsole();
  });
}

new Vue({
  router,
  created() {
    return (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.com/en_US/messenger.Extensions.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "Messenger");
  },
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
